<template>
  <div class="view">
    <UserSearch
      class="user-search"
      @selected="onUserSelect"
      :addButton="false"
    />

    <div class="list">
      <div class="media" v-for="media in list" :key="media.id">
        <!-- <img :src="media.preview" @click="openMedia(media)" /> -->
        <router-link
          v-if="media.user"
          :to="'/chats/' + media.user.supportChat"
          class="z-1 user relative"
        >
          Чат с юзером
        </router-link>

        <uiImage :url="media.url" w="200" radius-class="rounded-0" />
      </div>
    </div>

    <div style="padding: 30px 0">
      <uiButton
        style="width: 200px; margin: 0 auto"
        color="grey"
        @click="load(true)"
        v-if="!noMore"
      >
        Загрузить ещё
      </uiButton>
    </div>
  </div>
</template>

<script>
import UserSearch from '@/components/UserSearch'
import { API } from '@/config'
import { format } from 'date-fns'

export default {
  name: 'PetMediaPage',
  props: {
    id: String
  },
  components: {
    UserSearch
  },
  data () {
    return {
      loading: false,
      list: [],
      noMore: false
    }
  },
  watch: {
    id (nv, pv) {
      if (nv === pv) return
      this.list = []
      this.noMore = false
      this.load()
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    onUserSelect (u) {
      if (this.id === u.id) return
      this.$router.push('/petmedia/' + u.id)
    },
    format (date) {
      return format(new Date(date), 'HH:mm | dd.MM.yyyy')
    },
    async load (after, before) {
      if (this.loading) return
      this.loading = true

      let payload = {
        user: this.id
      }
      if (after) payload.after = this.list[this.list.length - 1].id
      if (before) payload.before = this.list[0].id

      let { data } = await this.$http.post(API.PETMEDIA.list, payload)

      if (!data || data.err) this.$notify(data.err)
      if (data === []) return (this.loading = false)

      if (after) {
        this.list = this.list.concat(data)
      } else if (before) {
        this.list = data.concat(this.list)
      } else {
        this.list = data || []
      }
      if (data.length < 30) this.noMore = true
      this.loading = false
    },
    async openMedia (media) {
      this.$events.$emit('imageViewer', media.url)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.view {
  width: 100%;
}

.user-search {
  margin-top: 50px;
}

.list {
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-wrap: wrap;
  margin: 0px auto;
  margin-top: 30px;

  .media {
    width: 200px;
    height: 200px;
    position: relative;
    overflow: hidden;
    cursor: pointer;

    img {
      display: block;
      width: 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .user {
      width: 100%;
      text-align: center;
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.5),
        rgba(0, 0, 0, 0)
      );
      padding: 10px 0;
      position: absolute;
      color: #fff;
      opacity: 0.5;
    }

    .user:hover {
      opacity: 1;
    }
  }
}
</style>
